import styled from 'styled-components'

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  border-radius: 4px;
  color: #546e7a;
  font-size: 0.75rem;
  font-weight: 400;
  margin-bottom: 0.5rem;
  font-family: 'Inter', sans-serif;
`

export const ModalDescription = styled.span`
  font-weight: 400;
  font-size: 0.875rem;
  font-family: 'Inter', sans-serif;
  display: block;
  margin-top: -1rem;
  color: #333333;
  text-align: center;
`

export const HighlightMessage = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  color: #37474F;
  font-size: 0.8rem;
  line-height: 1.5;

  display: flex;
  align-items: center;
  text-align: left;

  background-color: #E8EAF6;
  padding: 12px 16px;
  border-radius: 8px;

  margin-top: 0.5rem;
`
